const RESERVATION_ID_KEY = 'chekin-reservation-id';
const EXTERNAL_ID_KEY = 'chekin-external-id';
const RESERVATION_DETAILS = 'chekin-can-edit-reservation-details';
const SDK_STYLES = 'embedded-chekin-styles';
const SDK_STYLES_LINK = 'embedded-chekin-styles-link';
const CHEKIN_ROOT_IFRAME_ID = 'chekin-root-iframe';

enum SDK_MODE {
  all = 'ALL',
  onlyGuestForm = 'ONLY_GUEST_FORM',
  onlyIV = 'IV_ONLY',
  propertyLink = 'PROPERTY_LINK',
  guestRegistrationOnly = 'GUEST_REGISTRATION_ONLY',
}

export {
  RESERVATION_ID_KEY,
  EXTERNAL_ID_KEY,
  RESERVATION_DETAILS,
  SDK_STYLES,
  SDK_STYLES_LINK,
  CHEKIN_ROOT_IFRAME_ID,
  SDK_MODE,
};
